import { render, staticRenderFns } from "./ProductBarcodeLabel.vue?vue&type=template&id=801bde1e&scoped=true"
import script from "./ProductBarcodeLabel.vue?vue&type=script&lang=js"
export * from "./ProductBarcodeLabel.vue?vue&type=script&lang=js"
import style0 from "./ProductBarcodeLabel.vue?vue&type=style&index=0&id=801bde1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801bde1e",
  null
  
)

export default component.exports